<template>
  <div id="app">
    <AGWAudio :file="music.file" :loop="music.loop" :autoplay="music.autoplay"/>
    <AGWHero overlay :images="backgrounds" ref="hero" parallax target="#intro"/>

    <div class="agw-content bg-white" :style="{ 'margin-top' : `${$root.hero.height}px` }">
      <AGWIntro id="intro"/>

      <Doa />

      <AGWPawiwahan id="pawiwahan" class="py-5"/>
      <AGWMepandes id="mepandes" class="pad-y-60" :mepandes="mepandes"/>

      <AGWCounter
        id="counter"
        class="pad-y-60"
        :background="background"
        :date="time.start"
      />
      <AGWGallery id="gallery" class=""/>
      <AGWMap
        :height="450"
        url="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3944.5632965732443!2d115.27767071453611!3d-8.637853390214303!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2dd23ffd6b497c5f%3A0x32d448879f16fbc3!2sD&#39;Kintamani%20Restaurant!5e0!3m2!1sen!2sid!4v1584027969054!5m2!1sen!2sid"
        directionUrl="https://www.google.com/maps/dir//D'Kintamani+Restaurant,+Jl.+Prof.+Dr.+Ida+Bagus+Mantra+No.88A,+Ketewel,+Sukawati,+Gianyar,+Bali+80582/@-8.6378534,115.2776707,17z/data=!4m9!4m8!1m0!1m5!1m1!1s0x2dd23ffd6b497c5f:0x32d448879f16fbc3!2m2!1d115.2798594!2d-8.6378587!3e0"
        :location="location"
        id="map"
      />
    </div>

    <div class="agw-content" style="background: transparent">
      <attendance id="attendance" class="pad-y-60"></attendance>
    </div>

    <section class="footer bg-white pad-y-20" ref="footer">
      <div class="font-weight-lighter">
        &copy; {{ $moment().format('YYYY') }}. Made by <a href="https://ceremonyku.com">ceremonyku</a>.
      </div>
    </section>

    <transition name="slide-fade">
      <guest-box :floating="true" v-if="$root.scroll.Y > $root.hero.height"/>
    </transition>

    <div class="snackbar" v-if="sw.updateExists">
      New version available!
      <button @click="refreshApp" class="btn">REFRESH</button>
    </div>
  </div>
</template>

<script>
const ImageHero1 = 'https://ik.imagekit.io/aryraditya/surya-febi/CAR_7079__1__m-TWJs688.jpg'
const ImageHero2 = 'https://ik.imagekit.io/aryraditya/surya-febi/CAR_7314_xq_iGQBeZ.jpg'

import Audio from "@/assets/audio/gender-wayang.mp3";

import AGWHero from "@/components/Hero/HeroTwo";
import AGWIntro from "@/components/Intro";
import AGWPawiwahan from "@/components/Pawiwahan";
import AGWMepandes from "@/components/Mepandes";
import AGWCounter from "@/components/Counter";
import AGWGallery from "@/components/Gallery/GalleryTwo";
import AGWMap from "@/components/Maps";
import AGWAudio from "@/components/Audio";
import GuestBox from "@/components/GuestBox";
import Attendance from "@/components/Attendance";
import Doa from '@/components/Doa'

import { setInterval } from "timers";

export default {
  name: "app",
  components: {
    AGWHero,
    AGWIntro,
    AGWPawiwahan,
    AGWMepandes,
    AGWCounter,
    AGWGallery,
    AGWMap,
    AGWAudio,
    GuestBox,
    Attendance,
    Doa
  },
  data() {
    return {
      title: 'Pawiwahan',
      backgrounds: [ImageHero1, ImageHero2],
      bgActive: 0,
      dividerHeight: 0,
      location: "D'Kintamani Resto, Jl. Bypass Prof. Dr. Ida Bagus Mantra No. 88A, Ketewel, Gianyar - Bali",
      // date: "2020-04-05",
      time: {
        start: this.$moment("2020-09-04 11:00"),
        end: "17:00"
      },
      wedding: {
        man: {
          name: 'Nyoman Surya Maha Putra, S.Par',
          surname: 'Surya',
          parents: 'Dr. Ir. Made L. Nurdjana & Nyoman Setiani, S.I.P',
          description: 'Putra ketiga',
          address: '',
        },
        woman: {
          name: 'dr. Ni Komang Ayu Febi Wiradiani',
          surname: 'Febi',
          parents: 'Kombes. Pol (Purn) I Ketut Wiardana, S.H & Ni Wayan Subakti',
          address: '',
          description: 'Putri ketiga',
        },
      },
      mepandes: [
      ],
      gallery: [
        'https://ik.imagekit.io/aryraditya/surya-febi/CAR_7349_copy_9XAHcqTpeJ0.jpg',
        'https://ik.imagekit.io/aryraditya/surya-febi/CAR_7282_copy_JxxeLv3Ix.jpg',
        'https://ik.imagekit.io/aryraditya/surya-febi/CAR_7253_copy_k4uOOq648.jpg',
        'https://ik.imagekit.io/aryraditya/surya-febi/CAR_7239_copy_b3SM6H11Y.jpg',
        'https://ik.imagekit.io/aryraditya/surya-febi/CAR_7088_copy_WLGwPt1PZx.jpg',
        'https://ik.imagekit.io/aryraditya/surya-febi/CAR_6969_copy_RFiYx1zVRK.jpg',
      ],
      music: {
        file: Audio,
        autoplay: true,
        loop: true
      },
      sw: {
        refreshing: false,
        registration: null,
        updateExists: false
      }
    };
  },
  computed: {
    background() {
      return this.backgrounds[this.bgActive];
    }
  },
  mounted() {
    this.dividerHeight = `calc(100vh - ${this.$refs.footer.offsetHeight}px)`;
    setInterval(() => {
      let active = this.bgActive + 1;
      if (active >= this.backgrounds.length) {
        active = 0;
      }

      this.bgActive = active;
    }, 5000);
  },
  created() {
    document.addEventListener("swUpdated", this.showRefreshUI, { once: true });
    if(navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (this.sw.refreshing) return;
      this.sw.refreshing = true;
      window.location.reload();
    });
    }
  },
  methods: {
    showRefreshUI(e) {
      this.sw.registration = e.detail;
      this.sw.updateExists = true;
    },
    refreshApp() {
      this.sw.updateExists = false;
      if (!this.sw.registration || !this.sw.registration.waiting) {
        return;
      }
      this.sw.registration.waiting.postMessage("skipWaiting");
    }
  }
};
</script>
